import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';

import { FormTableError } from 'components/_basic/Form/FormTableComponent/components/FormTableError/FormTableError';
import { TextLinkComponent } from 'components/_basic/TextLinkComponent';

import { ISalesAndMarketingErrorMessageProps } from './types';

export const SalesAndMarketingErrorMessage: React.FC<ISalesAndMarketingErrorMessageProps> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <FormTableError
      message={
        <Typography variant="subtitle2" component={TextLinkComponent} fontWeight={700} onClick={onClick}>
          {t('financialPlan.plannedExpenses.monthlyExpenses.salesAndMarketing')}
        </Typography>
      }
    />
  );
};
